// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onboarding-container[data-v-6337a567]{min-height:186px}@media only screen and (max-width:1263px){.container[data-v-6337a567]{max-width:none!important}}[data-v-6337a567] .v-list-item--disabled .v-list-item__content{color:rgba(0,0,0,.38)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
